module.exports = __webpack_public_path__ + "img/logo.818c2303.png";